export default __webpack_public_path__ + "static/media/nextImage.353f3780.svg";